module.exports = __webpack_public_path__ + "Roboto-ThinItalic.11b5cc9584f2c007a229.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/rujuta/Desktop/Projects/agiletimes-master/node_modules/roboto-fontface/fonts/roboto/Roboto-ThinItalic.ttf
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-ThinItalic.ttf
// module chunks = styles